import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';

import { ApplicationConfig } from './application.config';

/**
 * The locale files keep their names from build to build, so a browser kept
 * the previous version's en.json and showed the new keys instead of texts
 * until a hard reload. The version in the address makes every release fetch
 * them anew; the version is raised with every release.
 */
function translateHttpLoaderFactory(
  httpBackend: HttpBackend
): TranslateHttpLoader {
  return new TranslateHttpLoader(
    new HttpClient(httpBackend),
    '/assets/i18n/',
    `.json?v=${ApplicationConfig.version}`
  );
}

export const TranslateConfig: TranslateModuleConfig = {
  defaultLanguage: 'en',
  loader: {
    provide: TranslateLoader,
    useFactory: translateHttpLoaderFactory,
    deps: [HttpBackend],
  },
};
